export default "__VITE_ASSET__BhyaGFRa__"